import { Icon, Tooltip } from '@smartgift/frontend-toolkit';
import { useTranslation } from 'react-i18next';

import { useDevice } from '@hero/hooks';
import { useSidebar } from '@hero/store/hooks';

import * as S from './style';
import { useSidebarItems } from './useSidebarItems';

export function SidebarItems() {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const { isSidebarOpen, closeSidebar } = useSidebar();
  const sidebarItems = useSidebarItems();

  return (
    <S.SidebarItems>
      {sidebarItems.map(item => {
        if (item.status === 'disabled') return null;

        return (
          <Tooltip
            key={item.value}
            size="sm"
            tooltipConfig={{
              placement: 'left',
              offset: [0, 12]
            }}
            content={t(item.label)}
          >
            <S.SidebarItem to={item.link} onClick={isMobile && closeSidebar}>
              <Icon name={item.icon} size="lg" />
              {isSidebarOpen && (
                <S.SidebarItemLabel variant="heading3">{t(item.value)}</S.SidebarItemLabel>
              )}
            </S.SidebarItem>
          </Tooltip>
        );
      })}
    </S.SidebarItems>
  );
}
